<template>
  <div>
    <button @click="showModal = true">
      Show Assignable Devices ({{ devices.length }})
    </button>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Available Devices</h3>
        <div v-if="loading">Loading...</div>
        <div v-else-if="devices.length === 0">No devices ready for registration.</div>
        <ul v-else>
          <li v-for="device in devices" :key="device.id">
            {{ device.name }} (Wireguard: {{ device.wireguard_ip || 'N/A' }})
          </li>
        </ul>
        <div class="modal-buttons">
          <button @click="showModal = false">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceRegistrationAPIService from "@/servicehandlers/DeviceRegistrationAPIService";
const deviceRegistrationAPIService = new DeviceRegistrationAPIService();
export default {
  name: "AssignableDeviceList",
  data() {
    return {
      showModal: false,
      devices: [],
      loading: false
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.fetchDevices();
      }
    }
  },

  methods: {
    async preloadDeviceCount() {
      try {
        const response = await deviceRegistrationAPIService.getAssignableDevices(this.$router, this.$store);
        this.devices = response?.devices || [];
      } catch (error) {
        console.error("Error preloading device count", error);
      }
    },
    async fetchDevices() {
      this.loading = true;
      try {
        const response = await deviceRegistrationAPIService.getAssignableDevices(this.$router, this.$store);
        this.devices = response?.devices || [];
      } catch (error) {
        console.error("Error loading devices", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #222;
  color: #fff;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  max-width: 90%;
}

ul {
  list-style-type: disc;
  padding-left: 1.5rem; /* Indents the bullet points */
  margin-top: 10px;
  margin-bottom: 10px;
}

li {
  margin-bottom: 8px; /* Adds space between list items */
  line-height: 1.5;
}

.modal-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>
